import { darkColors, lightColors } from '@tryhackme/thm-ui-components';
import { css } from 'styled-components';

export const TextAndBackgroundColorStyles = css<{ $isDark: boolean }>`
  background-color: ${({ $isDark }) => ($isDark ? darkColors.background.dark : lightColors.background.light)};
  color: ${({ $isDark }) => ($isDark ? darkColors.text.light : lightColors.text.main)};
`;
